export default __webpack_public_path__ + "static/media/karlaHernandez.6c9fb023.png";